import ShopFinancialStatusSettingsSection from './shop-financial-status-settings-section';

export default ShopFinancialStatusSettingsSection;
